﻿import { Utils } from './ObjectUtils.js';

export class WindowResizeMonitor {
  constructor(startImmediately) {
    this.resizeTimeout = null;
    this.isActive = false;
    if (startImmediately) {
      this.toggleMonitor(true);
    }
  }

  resizeThrottler() {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if (!this.resizeTimeout) {
      const timeoutMs = 66; // The actual resize method will execute at a rate of 15fps
      this.resizeTimeout = setTimeout(() => {
        this.resizeTimeout = null;
        if (this.onResize) {
          this.onResize(this);
        }
      }, timeoutMs);
    }
  }

  toggleMonitor(on) {
    if (on !== this.isActive) {
      this.isActive = on;
      if (on) {
        this.resizeHandler = Utils.addEventListener(window, 'resize',
          event => this.resizeThrottler(event));
      } else {
        Utils.removeEventListener(this.resizeHandler);
      }
    }
  }
}
